import React from "react";
import ReactDOM from "react-dom/client";
import "./theme.css";
import App from "./App";
// The page that reads `needs_password` from the invite check. The one that
// lived in components/auth always asked for a password, so somebody already in
// another fund was made to "set" one they had, and it was the route that won:
// this file registers /join-organisation before App.js ever sees it.
import JoinOrganisation from "./components/joinorganisation/JoinOrganisation";
import Signin from "./components/auth/Signin";
import ForgotPassword from "./components/forgotpassword/ForgotPassword";
import ApplicationForm from "./components/forms/ApplicationForm";
import PrivacyPolicy from "./components/legal/PrivacyPolicy";
import DeleteAccount from "./components/legal/DeleteAccount";
import { AuthProvider } from "./context/AuthProvider";
import { BrowserRouter, Route, Routes } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/join-organisation" element={<JoinOrganisation />} />
      <Route path="/signin" element={<Signin />} />
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/application-form" element={<ApplicationForm />} />
      {/* Public: Google Play links to both. */}
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/delete-account" element={<DeleteAccount />} />
      <Route path="/*" element={
        <AuthProvider>
          <App />
        </AuthProvider>
      } />
    </Routes>
  </BrowserRouter>
);
